module.exports = __webpack_public_path__ + "static/media/pig.2c9fd913.png";